module.exports = require("function-overloader");


//////////////////
// WEBPACK FOOTER
// external "function-overloader"
// module id = 6
// module chunks = 0